<template>
<div class="chapter">
<div class="inner_page">
<p class="sink"> </p>
<h1 class="chaptertitle parttitle">GOLD</h1>
<p class="center ">
<b>I</b>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c001.vue?114ce747